const POST = "POST";
const GET = "GET";
// eslint-disable-next-line
const DELETE = "DELETE";
// eslint-disable-next-line
const PATCH = "PATCH";

// eslint-disable-next-line
export default {
  //destinations
  GetAllDestinations: {
    method: GET,
    url: "/member/destinations",
    useAuth: true,
  },
  GetAllDestinationsWithoutPagination: {
    method: GET,
    url: "/member/destinations-all",
    useAuth: true,
  },
  GetSingleDestinations: {
    method: GET,
    url: "/member/destination",
    useAuth: true,
  },
  //travelStyle
  GetAllTravelStyles: {
    method: GET,
    url: "/travel-styles",
    useAuth: true,
  },
  GetSingleTravelStyles: {
    method: GET,
    url: "/travel-style",
    useAuth: true,
  },
  //userProfile
  getUserProfile: {
    method: GET,
    url: "/member",
    useAuth: true,
  },
  updateAvatar: {
    method: POST,
    url: "/member/upload-avatar",
    useAuth: true,
  },
  updateProfile: {
    method: POST,
    url: "/member?_method=patch",
    useAuth: true,
  },
  updatePassword: {
    method: POST,
    url: "/member/password",
    useAuth: true,
  },
  //trips
  getAllTrips: {
    method: GET,
    url: "/trip/getAll",
    useAuth: true,
  },
  // newsletter
  subscribe: {
    method: POST,
    url: "/subscribe",
    useAuth: true,
  },
  soloSubscribe: {
    method: POST,
    url: "/solo-subscribe",
    useAuth: true,
  },
  // request a quote
  requestAQuote: {
    method: POST,
    url: "/member/tour/quote",
    useAuth: true,
  },
  // get all cities
  getCities: {
    method: GET,
    url: "/cities",
    useAuth: true,
  },
  // get all country
  getCountry: {
    method: GET,
    url: "/countries",
    useAuth: true,
  },
  getCountryFeatured: {
    method: GET,
    url: "/countries-featured",
    useAuth: true,
  },
  // verify domain
  verifyDomain: {
    method: GET,
    url: "/checkDomain/trip",
    useAuth: false,
  },
  // verify domain
  getAllSuppliers: {
    method: GET,
    url: "/get-all-suppliers",
    useAuth: true,
  },
  // with deals
  getAllTripsWithDeals: {
    method: GET,
    url: "/trip/getAll-with-deals",
    useAuth: true,
  },
  getAllTripsWithDealsNew: {
    method: GET,
    url: "/member/deals",
    useAuth: true,
  },
  // with all filters
  getAllTripsWithFilters: {
    method: POST,
    url: "/trip/getAll-with-filters",
    useAuth: true,
  },
  // general filter
  generalFilter: {
    method: GET,
    url: "/trip/filter",
    useAuth: true,
  },
  // book now request
  bookNow: {
    method: POST,
    url: "/member/tour/booking/create",
    useAuth: true,
  },
  // book now request
  newBookNow: {
    method: POST,
    url: "/member/tour/new-booking/create",
    useAuth: true,
  },
  // trip group
  getAllTripMerchantJourneysTrips: {
    method: GET,
    url: "/trip-merchant-journeys-group-departures",
    useAuth: false,
  },
  // featured
  getAllFeaturedTrips: {
    method: GET,
    url: "/get-featured-trips",
    useAuth: false,
  },
  inquiries: {
    method: POST,
    url: "/member/inquiries/save",
    useAuth: true,
  },
  reservation: {
    method: POST,
    url: "/member/tour/reservation/create",
    useAuth: true,
  },
  getFilterForBlogs: {
    method: GET,
    url: "/member/uuids",
    useAuth: false,
  },
  getShips: (sleg) => {
    return {
      method: GET,
      url: `/get-ships/${sleg}`,
      useAuth: true,
    };
  },
  getDurations: (sleg) => {
    return {
      method: GET,
      url: `/get-duration/${sleg}`,
      useAuth: true,
    };
  },
  getDurations: (sleg) => {
    return {
      method: GET,
      url: `/get-duration/${sleg}`,
      useAuth: true,
    };
  },
  getDestinations: (sleg) => {
    return {
      method: GET,
      url: `/get-destinations/${sleg}`,
      useAuth: true,
    };
  },
  getCruiseLines: (sleg) => {
    return {
      method: GET,
      url: `/get-cruise-lines/${sleg}`,
      useAuth: true,
    };
  },
  getFav: {
    method: GET,
    url: "/favourite-trips",
    useAuth: true,
  },
  addToFav: (slug) => {
    return {
      method: POST,
      url: `/trip/${slug}/add-to-favourite`,
      useAuth: true,
    };
  },
  getReservation: {
    method: GET,
    url: "/member/tour/reservation/index",
    useAuth: true,
  },
  addTestimonial: {
    method: POST,
    url: "/member/testimonial/send",
    useAuth: true,
  },
  newBookNowIndex: {
    method: GET,
    url: "/member/tour/new-bookings",
    useAuth: true,
  },
  askQuestion: {
    method: POST,
    url: "/member/ask-question",
    // useAuth: true,
  },
  groupedTravelStyles: {
    method: GET,
    url: "/member/grouped-travel-styles",
    useAuth: true,
  },
};
